import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';



const SliderItem: React.FC<any> = ({ title, description, features, imageUrl, id, groupSefURL, detailsTitle }) => {
  return (
    <div className="item">
      <div className="container">
        <div className="slider-text">
          <h1>
            <span>{title}</span>
          </h1>
          <p>{description}</p>
          <ul className="medicom-feature-list list-inline text-left">
            {features?.map((feature: any, index: number) => (
              <li key={index + "-" + feature}>
                <i className="fa fa-check medicom-check"></i>
                {feature}
              </li>
            ))}
          </ul>
          <Link to={groupSefURL} className="btn btn-default btn-rounded">
            {detailsTitle}
          </Link>

        </div>
        <div className="slider-image">
          <img src={imageUrl} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        </div>
      </div>
    </div>
  );
};

export default SliderItem;
